<template>
  <v-container>
    <material-card
      :title="Item.title"
      :text="Item.subTitle"
      color="green"> 
      <v-form
      ref="form"
      v-model="valid"
      lazy-validation>
        <v-container py-0>
          <v-layout wrap>
            <v-flex md6>
               <v-text-field
                type="text"
                :label="'Title'"
                :name="'Title'"
                class="green-input"
                 v-model="Value.title"
                 :rules="titleRules"
                 />
                 
            </v-flex>
         
            <v-flex md6>
               <v-text-field
                type="text"
                :label="'Title (Bangla)'"
                :name="'Title'"
                class="green-input"
                 v-model="Value.title_bn"
                 :rules="titleBnRules"
                 />
                 
            </v-flex>

            <v-flex md12>
               <v-text-field
                type="text"
                :label="'Description'"
                :name="'Description'"
                class="green-input"
                 v-model="Value.description"
                 />
                 
            </v-flex>
            <v-flex md6>
               <v-text-field
               ref="sequence"
                type="number"
                :label="'Sequence'"
                :name="'sequence'"
                class="green-input"
                 v-model="Value.sequence"
                 />
                 
            </v-flex>
            
            <v-flex md6>
               <v-text-field
                type="number"
                :label="'Price'"
                :name="'price'"
                class="green-input"
                 v-model="Value.price"
                 />
                 
            </v-flex>

            
            <v-flex md6>
               <v-text-field
                type="text"
                :label="'Tutor Name'"
                :name="'tutorName'"
                class="green-input"
                 v-model="Value.tutor_name"
                 />
                 
            </v-flex>
            <v-flex md6>
               <v-text-field
                type="text"
                :label="'Institute'"
                :name="'institute'"
                class="green-input"
                 v-model="Value.tutor_info"
                 />
                 
            </v-flex>

            <v-flex md6>
               <v-text-field
                type="text"
                :label="'Youtube URL'"
                :name="'YoutubeURL'"
                class="green-input"
                 v-model="Value.youtube_url"
                 />

            </v-flex>

            <v-flex md6>
               <v-text-field
                type="text"
                :label="'Youtube ID'"
                :name="'YoutubeID'"
                class="green-input"
                 v-model="Value.youtube_video_id"
                 />
                 
            </v-flex>




            <v-flex
              xs12
              text-xs-right>
              <v-btn
                class="mx-0 font-weight-light"
                color="success" @click="onClickButton">{{ Item.submitText }}</v-btn>
              <v-btn
                class="mx-2 font-weight-light"
                color="info" @click="closeModal">Close</v-btn>
                
            </v-flex> 
          </v-layout>
        </v-container>
      </v-form>
    </material-card>
  </v-container>
</template>

<script>
export default {
  props: {
    // title: String,
    Item: Object,
    Field: Array,
    CourseTypeList: Array,
    Value: Object
  },
  watch: {
    dialog() {
        this.$refs.form.reset()
    }
  },
  data () {
      return {
      overlay: false,
      valid: true,
      modelList: {'course_type_id': null},
      titleRules: [
        v => !!v || 'Course title is required',
        v => (v && v.length <= 190) || 'Course title must be less than 190 characters',
        
      ],
      titleBnRules: [
        v => !!v || 'Course title Bangla is required',
        v => (v && v.length <= 190) || 'Course title bangla must be less than 190 characters'
      ],
      statusRules: [
        v => !!v || 'Status is required',
        v => (v && v.length <= 30) || 'Status must be less than 30 characters'
      ],
      priceRules: [
        v => !!v || 'Price is required',
      ],
      statusList: [
        { item: 'active'},
        { item: 'inactive'},
      ]
      }
  },

  created () {
    this.$refs.sequence.focus()
    console.log(this.Value)
    this.modelList = this.Value
  },
  methods: {
    onClickButton (event) {
      if (this.$refs.form.validate()) {
        this.overlay = true
        this.$emit('emitted', this.Value)
      } else {
        console.log('Second')
      }
    },
    closeModal () {
      this.$emit('closed')
    }
  }
}
</script>
